import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@mui/material";
import {
  SaveChemical,
  UpdateChemical,
} from "../../../services/GeneralMaintenanceService";
import { NotificationManager } from "react-notifications";

const AddEditChemicalDialog = ({ open, onClose, onSave, selectedChemical }) => {
  const initialState = {
    chemicalId: "",
    chemicalName: "",
    dateReceived: "",
    userName: "",
    containerName: "",
    location: "",
    inventoryQuantity: "",
    disposalDate: "",
    expirationDate: "",
    expirationInterval: "",
    reorderDate: "",
    reorderQuantity: "",
    description: "",
    comments: "",
    recordid:0
  };

  const [chemicalData, setChemicalData] = useState(initialState);

  useEffect(() => {
    if (selectedChemical) {
      setChemicalData({
        chemicalId: selectedChemical.chemicalId || "",
        chemicalName: selectedChemical.chemicalName || "",
        dateReceived: selectedChemical.dateReceived
          ? new Date(selectedChemical.dateReceived)
              .toISOString()
              .substring(0, 10)
          : "",
        userName: selectedChemical.userName || "",
        containerName: selectedChemical.containerName || "",
        location: selectedChemical.location || "",
        inventoryQuantity: selectedChemical.inventoryQuantity || "",
        disposalDate: selectedChemical.disposalDate
          ? new Date(selectedChemical.disposalDate)
              .toISOString()
              .substring(0, 10)
          : "",
        expirationDate: selectedChemical.expirationDate
          ? new Date(selectedChemical.expirationDate)
              .toISOString()
              .substring(0, 10)
          : "",
        expirationInterval: selectedChemical.expirationInterval || "",
        reorderDate: selectedChemical.reorderDate
          ? new Date(selectedChemical.reorderDate)
              .toISOString()
              .substring(0, 10)
          : "",
        reorderQuantity: selectedChemical.reorderQuantity || "",
        description: selectedChemical.description || "",
        comments: selectedChemical.comments || "",
        recordid: selectedChemical.recordid || 0,
      });
    } else {
      setChemicalData(initialState);
    }
  }, [selectedChemical]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setChemicalData((prevData) => ({
      ...prevData,
      [name]: value === "" ? null : (isNaN(value) ? value : parseInt(value)),
    }));
  };
  

  const handleSave = async () => {
    try {
      // Prepare the data
      const preparedData = {
        ...chemicalData,
        expirationInterval: chemicalData.expirationInterval || null,
        expirationDate: chemicalData.expirationDate || null,
        disposalDate: chemicalData.disposalDate || null,
        reorderDate: chemicalData.reorderDate || null,
        dateReceived: chemicalData.dateReceived || null,
      };
  
      let response;
      if (selectedChemical) {
        response = await UpdateChemical(preparedData);
        NotificationManager.success("Chemical updated successfully");
      } else {
        response = await SaveChemical(preparedData);
        NotificationManager.success("Chemical saved successfully");
      }
  
      if (response.status === 200) {
        onSave();
        onClose();
      } else {
        NotificationManager.error("Error saving/updating Chemical");
      }
    } catch (error) {
      NotificationManager.error("Error saving/updating Chemical");
    }
  };
  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {selectedChemical ? "Edit Chemical" : "Add New Chemical"}
      </DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="chemicalName"
              label="Chemical Name"
              type="text"
              fullWidth
              value={chemicalData.chemicalName}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="dateReceived"
              label="Date Received"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={chemicalData.dateReceived}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="userName"
              label="User Name"
              type="text"
              fullWidth
              value={chemicalData.userName}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="containerName"
              label="Container Name"
              type="text"
              fullWidth
              value={chemicalData.containerName}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="location"
              label="Location"
              type="text"
              fullWidth
              value={chemicalData.location}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="inventoryQuantity"
              label="Inventory Quantity"
              type="number"
              fullWidth
              value={chemicalData.inventoryQuantity}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="disposalDate"
              label="Disposal Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={chemicalData.disposalDate}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="expirationDate"
              label="Expiration Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={chemicalData.expirationDate}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="expirationInterval"
              label="Expiration Interval (in days)"
              type="number"
              fullWidth
              value={chemicalData.expirationInterval}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="reorderDate"
              label="Reorder Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={chemicalData.reorderDate}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="reorderQuantity"
              label="Reorder Quantity"
              type="number"
              fullWidth
              value={chemicalData.reorderQuantity}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="description"
              label="Description"
              type="text"
              fullWidth
              value={chemicalData.description}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: "1 1 30%" }}>
            <TextField
              margin="dense"
              name="comments"
              label="Comments"
              type="text"
              fullWidth
              value={chemicalData.comments}
              onChange={handleChange}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEditChemicalDialog;
